import { render } from "./Lessons.vue?vue&type=template&id=0ae7bee5"
import script from "./Lessons.vue?vue&type=script&setup=true&lang=js"
export * from "./Lessons.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/modules/learning_module/components/lesson/Lessons.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0ae7bee5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0ae7bee5', __exports__)) {
    api.reload('0ae7bee5', __exports__)
  }
  
  module.hot.accept("./Lessons.vue?vue&type=template&id=0ae7bee5", () => {
    api.rerender('0ae7bee5', render)
  })

}


export default __exports__